import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import RaisedButton from 'material-ui/RaisedButton';
import Loader from 'react-loader-spinner';
var Config = require('../../../config');

class ModalSearchFingerprint extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveFingerprint = this.saveFingerprint.bind(this);
		this.state = {
		    show: false,
		    showSaveBtn:false,
		    flagStart:false,
		    flagFinished:false,
		    fmd:"",
		    searching:true,
		    disableStartBtn:false
		};
	}

	componentDidMount() {
		this.props.onRef(this);
		
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
		//this.props.socket.close();
	}

	handleShow() {
		
		this.setState({ show: true,showSaveBtn:false,count:0,flagStart:false,flagFinished:false,disableStartBtn:false});

		this.props.socket.onerror = (event)=> {
			console.log(event);
			this.setState({disableStartBtn:true});
		};

		this.props.socket.onopen = (event)=> {
		   this.props.socket.send("initfp");
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);

		    if(res.MachineName){
		    	console.log(res.MachineName);
		    }

		    if (res.Huella){
		        console.log('fingerprint_image');
		    }

		    if (res.Error){
		    	if(res.Error === "No hay lector inicializado"){
		    		swal('Error', "No hay lector inicializado. Por favor verifique la conexión de su dispositivo y refresque la página", 'error');
		    	}else{
		        	swal('Error', res.Error, 'error');
		    	}
		    	this.setState({count:0,flagStart:false, flagFinished:false });
		    }

		    if (res.Mensaje)
		        console.log(res.Mensaje);

		    if (res.Fmd) {
		    	this.setState({ flagFinished:true,searching:true});
		    	fetch(Config.default.apiGateway.URL+'donors?huella='+res.Fmd, {
				 	method: 'POST', // or 'PUT'
				  	body: JSON.stringify(), // data can be `string` or {object}!
				  	headers: new Headers({
				  		'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				  		'Accept': 'application/json',
				  		'Content-Type': 'application/json;charset=UTF-8'
				  	})
				}).then(res => res.ok?res.json():this.setState({searching:false}))
				.catch(error => console.error('Error:', error))
				.then(response => {
					if(response !== undefined){
						this.props.save(response);
						this.setState({show:false});
					}
				});
		    	
		    }
		}
	}

	startRead = ()=>{
		try{
			this.props.socket.send("FPReset");
			this.props.socket.send('get');
			this.setState({ flagStart:true});
		}catch(error){
			console.log(error);
			swal('Error', 'Lector de huella no identificado','error');
		}
	}

	saveFingerprint(){
		if(this.state.fmd.length > 0){
			this.setState({ show: false});
			this.props.save(this.state.image,this.state.fmd);
		}else{
			swal('Error', 'No se ha realizado la lectura de ninguna huella','error');
		}
	}

	render(){
		const { t } = this.props;
		
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_fingerprint.search')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			{this.state.flagStart?
		        				<div>
		        					{!this.state.flagFinished?
										<div>
					        				<label>COLOQUE SU HUELLA</label>
				        				</div>
			        				:<div>
			        					{this.state.searching?
			        						<div>
		        							<label>BUSCANDO COINCIDENCIAS</label>
			        							<div style={{textAlign:'center'}}>
			        								<Loader 
			        									type="Oval" 
			        									color="#64b5f6" 
			        									height={80} 
			        									width={80}
			        									/> 
			        							</div>
			        						</div>
			        						:<label>NO SE ENCONTRÓ NINGUNA COINCIDENCIA</label>
			        					}	
			        				</div>}

		        				</div>
		        			:null}
		        			{!this.state.flagFinished&&!this.state.flagStart?
			        			<RaisedButton label="Iniciar Lectura" primary={true} onClick={this.startRead} style={{float:"right"}} disabled={this.state.disableStartBtn}/>
			        		:null}
			        	</div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	{this.state.showSaveBtn?<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.saveFingerprint}/>
		        	:null}
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalSearchFingerprint);